import { IResultado } from "interfaces/resultadoCorrida";
import { FormFieldConfig } from "interfaces/forms";

type Field = keyof Omit<IResultado, "id" | "eventoId">;

const formWiclax: FormFieldConfig<Field> = {
  filenameWiclax: {
    name: "filenameWiclax",
    label: "Arquivo Wiclax",
    type: "text",
    errorMsg: "Arquivo Wiclax obrigatorio",
  },
  filenamePdf: {
    name: "filenamePdf",
    label: "Arquivos PDF",
    type: "text",
    errorMsg: "Arquivos PDF obrigatorio",
  },
  urllink: {
    name: "urllink",
    label: "Link",
    type: "text",
    errorMsg: "Link obrigatorio",
  },
};

export default formWiclax;
